/**

 * Google Calendar OAuth flow helpers for campaign creation.

 * Scopes are unchanged — only routing/context differ from integration (`calendar`).

 */



export const CALENDAR_CAMPAIGN_CONTEXT = 'calendar-campaign' as const;



export function isCalendarCampaignContext(context: string | null | undefined): boolean {

  return context === CALENDAR_CAMPAIGN_CONTEXT;

}



/** Where to send the user after Calendar OAuth during campaign creation. */

export function getReturnPathAfterCalendarConnect(): string {

  return '/renewal-builder?from=google-calendar&step=calendar';

}



/** True when OAuth was started from the campaign wizard (not settings). */

export function isCalendarCampaignOAuthReturn(): boolean {
  return localStorage.getItem('calendar_oauth_return') === '1';
}



/** Read and clear campaign OAuth return markers; returns path to navigate to. */

export function consumeCalendarCampaignOAuthReturn(): string {
  const path =
    localStorage.getItem('calendar_oauth_return_path') ||
    getReturnPathAfterCalendarConnect();
  localStorage.removeItem('calendar_oauth_return');
  localStorage.removeItem('calendar_oauth_return_path');
  // Keep renewal_create_* keys for useRenewalCreate to restore the wizard
  return path;
}



/** Persist wizard state before same-tab Calendar OAuth redirect. */

export function persistCalendarOAuthWizardState(initialCampaignName?: string): void {

  localStorage.setItem('renewal_create_campaign_type', 'Calendar');

  localStorage.setItem('renewal_create_initial_step', 'calendar');

  localStorage.setItem('calendar_oauth_return', '1');

  localStorage.setItem('calendar_oauth_return_path', getReturnPathAfterCalendarConnect());

  if (initialCampaignName?.trim()) {

    localStorage.setItem('renewal_create_campaign_name', initialCampaignName.trim());

  }

}



export function parseCalendarConfigStepFromQuery(step: string | null): boolean {

  return step === 'calendar_config' || step === 'calendar';

}



/** postMessage context values that mean calendar OAuth succeeded. */

export function isCalendarOAuthMessageContext(context: string | null | undefined): boolean {

  return context === 'calendar' || context === CALENDAR_CAMPAIGN_CONTEXT;

}


